import { getConfig } from "./config";
import { getAuthToken } from "./getAuthToken";

export class APIError extends Error {
  status: number;
  data: any;

  constructor(message: string, status: number, data?: any) {
    super(message);
    this.name = "APIError";
    this.status = status;
    this.data = data;
  }
}

export const apiRequest = async (
  endpoint: string,
  method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH" = "GET",
  body: any = null,
  requireAuth = true,
  headers: Record<string, string> = {}
) => {
  const { apiUrl } = getConfig();

  let defaultHeaders: Record<string, string> = {
    "Content-Type": "application/json",
    ...headers,
  };

  // Only add authorization header if authentication is required
  if (requireAuth) {
    const authToken = await getAuthToken();

    if (authToken) {
      defaultHeaders = {
        ...defaultHeaders,
        Authorization: `Bearer ${authToken}`,
      };
    }
  }

  const options: RequestInit = {
    method,
    headers: defaultHeaders,
  };

  if (method != "GET") {
    let req_body = {};

    if (body) {
      req_body = body;
    }

    options.body = JSON.stringify(req_body);
  }

  try {
    const response = await fetch(`${apiUrl}${endpoint}`, options);

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch {
        throw new APIError("Request failed", response.status);
      }

      // Token expiration still returns silently
      if (errorData.detail?.includes("Token expired")) {
        return;
      }

      throw new APIError(
        errorData.error || errorData.detail || "Request failed",
        response.status,
        errorData
      );
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};

export default apiRequest;
